// src/components/DemoCard.tsx
import React from "react";
import { Button } from "@chakra-ui/react";
import { useResponsiveUi } from "../../hooks/ResponsiveUi/useResponsiveUi";
import {
  UiBaseProps,
  UiBorderWidth,
  UiColor,
  UiRounded,
  UiSize,
  UiVariant,
} from "../../utils/types/ui";

interface CustomButtonProps extends UiBaseProps {
  children?: React.ReactNode;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  loading?: boolean;
  loadingText?: string;
  onClick?: () => void;
  disabled?: boolean;
  asChild?: boolean;
  className?: string;
  spinner?: React.ReactElement;
  spinnerPlacement?: "start" | "end";
  ref?: React.Ref<HTMLButtonElement>;
  color?: string;
  bg?: string;
  width?: string;
  type?: "button" | "submit" | "reset" | undefined;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  asChild,
  children,
  iconLeft,
  iconRight,
  loading,
  loadingText,
  onClick,
  disabled,
  className,
  spinner,
  spinnerPlacement,
  ref,
  // UiBaseProps (overrides)
  size = { mob: UiSize.xs, tab: UiSize.sm, web: UiSize.md },
  fontSize = { mob: UiSize.xs, tab: UiSize.sm, web: UiSize.md },
  rounded = UiRounded.md,
  variant = UiVariant.subtle,
  colorPalette = UiColor.blue,
  color,
  shadow, //= `4px 4px 8px ${UiShadowColor.gray}`,
  padding,
  margin,
  borderWidth = UiBorderWidth.thin,
  lineHeight,
  letterSpacing,
  transition,
  bg,
  width = "full",
  type = "button",
}) => {
  const ui = useResponsiveUi({
    size,
    fontSize,
    rounded,
    variant,
    colorPalette,
    shadow,
    borderWidth,
    lineHeight,
    letterSpacing,
    transition,
  });

  return (
    <Button
      type={type}
      asChild={asChild}
      size={ui.size}
      fontSize={ui.fontSize}
      rounded={ui.rounded}
      variant={ui.variant}
      colorPalette={ui.colorPalette}
      color={color}
      loading={!!loading}
      loadingText={loadingText}
      onClick={onClick}
      disabled={!!disabled}
      shadow={ui.shadow}
      padding={padding as any}
      margin={margin as any}
      borderWidth={ui.borderWidth}
      lineHeight={ui.lineHeight}
      letterSpacing={ui.letterSpacing}
      transition={ui.transition}
      _hover={{ opacity: 0.9 }}
      _active={{ transform: "scale(0.86)" }}
      display="flex"
      alignItems="center"
      gap={2}
      className={className}
      spinner={spinner}
      spinnerPlacement={spinnerPlacement}
      ref={ref}
      bg={bg}
      w={width}
    >
      {iconLeft && (
        <span style={{ display: "inline-flex", marginRight: 6 }}>
          {iconLeft}
        </span>
      )}
      {children}
      {iconRight && (
        <span style={{ display: "inline-flex", marginLeft: 6 }}>
          {iconRight}
        </span>
      )}
    </Button>
  );
};

export default CustomButton;

// const [loading, setLoading] = useState(false);
// const handleClick = async () => {
//   setLoading(true);
//   await new Promise((res) => setTimeout(res, 2000)); // fake API
//   setLoading(false);
// };

// <CustomButton
//     loading={loading}
//      onClick={() => {
//       handleClick();
//     }}>Single</CustomButton>
//     // Single value
//      <CustomButton
//       size="md"
//       fontSize="sm"
//       rounded={UiRounded.full}
//       borderWidth={UiBorderWidth.thin}
//       colorPalette={UiColor.red}
//       variant={UiVariant.outline}
//     >
//       Single value
//     </CustomButton>
